/** SPA counterpart of marketing's CTA surface motion. Runtime-independent visual contract. */
export const marketingLiftGutterSx = {
  boxSizing: "border-box",
  ml: "4px",
  mr: "6px",
  mt: "4px",
  mb: "6px",
  maxWidth: "calc(100% - 10px)",
} as const;

export const marketingLiftSx = (shadow = "#ff3d00") =>
  ({
    transition: "transform 200ms ease, box-shadow 200ms ease",
    "&:hover, &:focus-visible": { boxShadow: `6px 6px 0 ${shadow}`, transform: "translate(-4px, -4px)" },
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none",
      "&:hover, &:focus-visible": { transform: "none" },
    },
  }) as const;
